// src/components/CookAI/Features/FeatureCard.tsx
import React from "react";
import { ColorTheme } from "../../../themes/colors";
import { getFeaturesStyles } from "../../../themes/styles/features";
import { Feature } from "../../../types";

interface FeatureCardProps {
    feature: Feature;
    theme: ColorTheme;
    isMobile?: boolean;
    index?: number;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ feature, theme, isMobile = false, index = 0 }) => {
    const styles = getFeaturesStyles(theme);

    // Alternate teal→blue / blue→teal so the grid doesn't feel repetitive
    const iconGradient = index % 2 === 0
        ? `linear-gradient(135deg, ${theme.primary} 0%, ${theme.secondary} 100%)`
        : `linear-gradient(135deg, ${theme.secondary} 0%, ${theme.primary} 100%)`;

    return (
        <div
            style={{
                ...styles.featureCard,
                ...(isMobile ? styles.mobileFeatureCard : {}),
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-6px)";
                e.currentTarget.style.boxShadow = `0 20px 44px rgba(7, 9, 26, 0.10), 0 6px 18px ${theme.primaryGlow}`;
                e.currentTarget.style.borderColor = `${theme.primary}55`;
                const icon = e.currentTarget.querySelector("[data-icon]") as HTMLElement;
                if (icon) icon.style.transform = "scale(1.08) rotate(-4deg)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 20px rgba(7, 9, 26, 0.05)";
                e.currentTarget.style.borderColor = theme.cardBorder;
                const icon = e.currentTarget.querySelector("[data-icon]") as HTMLElement;
                if (icon) icon.style.transform = "scale(1) rotate(0deg)";
            }}
        >
            <div
                style={{
                    ...styles.featureIcon,
                    background: iconGradient,
                    ...(isMobile ? styles.mobileFeatureIcon : {}),
                }}
                data-icon
            >
                {feature.icon}
            </div>
            <h3 style={{
                ...styles.featureTitle,
                ...(isMobile ? styles.mobileFeatureTitle : {}),
            }}>
                {feature.title}
            </h3>
            <p style={{
                ...styles.featureDesc,
                ...(isMobile ? styles.mobileFeatureDesc : {}),
            }}>
                {feature.description}
            </p>
        </div>
    );
};

export default FeatureCard;
